import React from 'react';
type CrossProps = {
  fillColor?: string;
  viewBox?: string;
};

export const Cross = ({ viewBox = '0 0 40 40', fillColor = 'white' }: CrossProps) => (
  <svg width="100%" height="100%" viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.0498 8.47935L15.6212 7.05078L12.0492 10.6228L8.47838 7.0519L7.0498 8.48047L10.6207 12.0513L7.0498 15.6222L8.47838 17.0508L12.0492 13.4799L15.6212 17.0519L17.0498 15.6233L13.4778 12.0513L17.0498 8.47935Z"
      fill={fillColor}
    />
  </svg>
);
